import * as checkoutApi from './checkout-api.js';
import * as stripe from './stripe.js';

export function createTotalManager({
    getBasketPayload = null,
    getEmail,
    getForm,
    getSessionId,
    getSessionType,
    getStripeAmount = (totals) => totals.full,
    onPromoError,
    onUpdate,
}) {
    let timeout = null;

    function destroy() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    }

    async function fetchTotals(overrideTotals = false) {
        if (getBasketPayload) {
            const payload = getBasketPayload();
            payload.checkout_session_type = getSessionType();

            if (overrideTotals) {
                payload.override_totals = '1';
            }

            return checkoutApi.getTotalJson(payload);
        }

        return checkoutApi.getTotal(
            getSessionType(),
            getForm(),
            overrideTotals,
        );
    }

    async function updateTotal(overrideTotals = false) {
        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(async () => {
            timeout = null;

            const totals = await fetchTotals(overrideTotals);

            stripe.updateAmount(getStripeAmount(totals));

            onUpdate(totals);
        }, 300);
    }

    async function applyPromoCode(code) {
        let response;

        if (getBasketPayload) {
            const payload = getBasketPayload();

            payload.checkout_session_id = getSessionId();
            payload.checkout_session_type = getSessionType();
            payload.code = code;
            payload.contact_email = getEmail();

            response = await checkoutApi.applyPromoCodeJson(payload);
        } else {
            response = await checkoutApi.applyPromoCode(
                getSessionId(),
                code,
                getEmail(),
            );
        }

        if (response.error) {
            onPromoError(response.error);
        } else {
            onPromoError('');
        }

        updateTotal();
    }

    async function removePromoCode() {
        if (getBasketPayload) {
            const payload = getBasketPayload();

            payload.checkout_session_id = getSessionId();
            payload.checkout_session_type = getSessionType();
            payload.code = '';
            payload.contact_email = getEmail();

            await checkoutApi.applyPromoCodeJson(payload);
        } else {
            await checkoutApi.applyPromoCode(getSessionId(), '');
        }

        onPromoError('');
        updateTotal();
    }

    return { applyPromoCode, destroy, removePromoCode, updateTotal };
}
